<template>
    <div class="assets_card" @click="jumpToDetail(item)">
        <img :src="list[0]" alt="" :style="{backgroundImage: 'url(' + (props.item.modelBgImage || 'https://dfsk-3d.oss-cn-shenzhen.aliyuncs.com/images/background01.png') + ')'}">
        <h6>{{ item.modelName }}  {{ item.modelFormat || '' }}</h6>
        <span class="icon1" v-if="item.assetSource">
            <img src="@/assets/imgs/icon56.png" v-if="item.assetSource == 1" alt="">
            <img src="@/assets/imgs/icon55.png" v-else alt="">
        </span>
        <span class="icon2" :style="{background: ['#A1BAC4', '#FF8D1A', '#FF5733', '#00BAAD', '#00BAAD', '#A1BAC4'][item.auditStatus]}" v-if="item.auditStatus !== undefined">
            {{ ['未发布', '待审核', '审核驳回', '审核成功', '已发布', '已下架', '-'][item.auditStatus] }}
        </span>
    </div>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import { useRouter } from 'vue-router';

const router = useRouter()

const props = defineProps({
    item: {
        type: Object,
        default: () => ({})
    }
})

const list = ref([]), currentIndex = ref(0), loading = ref(false)
onMounted(() => {
    list.value = props.item.modelCoverUrl.split(';')
})

function jumpToDetail(item) {
    router.push({ path: '/assets-detail', query: { id: item.id } })
    window.scrollTo(0, 0)
}

</script>

<style scoped lang="scss">
.assets_card {
    width: 100%;
    flex-shrink: 0;
    margin-right: 18rem;
    position: relative;
    padding-bottom: 10rem;
    >img{
        width: 100%;
        height: 140rem;
        object-fit: cover;
        background-size: cover;
    }
    h6{padding: 5rem 0; font-weight: normal; font-size: 14rem;}
    .icon1{
        position: absolute;
        top: 8rem;
        left: 8rem;
        width: 24rem;
        height: 24rem;
        display: block;
        img{
            width: 56rem;height: 20rem;
        }
    }
    .icon2{
        position: absolute;
        top: 8rem;
        right: 8rem;
        width: 68rem;
        height: 20rem;
        display: block;
        font-size: 12rem;
        text-align: center;
        background-color: #00BAAD;
        color: #FFF;
    }
}
</style>
